import React, { useContext } from 'react';
import { AuthContext } from '../contexts/authContext';

function ProtectedRoute({ children, ...rest }) {
    const { isAuthenticated, signinRedirect } = useContext(AuthContext);

    if (!!children && isAuthenticated()) {
        return children;
    } else {
        signinRedirect();
        return <span></span>;
    }
}

export default ProtectedRoute;
